<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row form-horizontal">
              <div class="form-group">
                <label class="col-sm-2 control-label"> {{$t("message.bannerName") }}</label>
                <div class="col-sm-3">
                  <div>
                    <input
                      type="text"
                      :placeholder="$t('message.bannerName')"
                      v-model="searchName"
                      name="search"
                      class="form-control input"
                      maxLength="30"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 textRight">
                  <div class>
                    <button class="btn btn btn-primary" @click="search">{{$t("message.Search") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive">
              <div class="col-xs-12">
                <p>{{floatingBannerList.length}}{{$t("message.datagridresult") }}</p>
              </div>
              <datatable :columns="columns" :data="floatingBannerList">
                <template scope="{ row }">
                  <tr @dblclick="datataleCli(row)" :style="trStyle">
                    <td align="center">
                      <select-row :row="row"></select-row>
                    </td>
                    <!-- <td>
                      <img style="width: 120px" :src="row['bannerImage']" :alt="`${row['bannerName'+$i18n.locale]} - img`" />
                    </td> -->
                    <td>
                      <span>{{row['bannerName'+$i18n.locale]}}</span>
                    </td>
                    <!-- <td>
                      <span>{{row['content'+$i18n.locale]}}</span>
                    </td>
                    <td>
                      <span>{{row['buttonUrl'+$i18n.locale]}}</span>
                    </td> -->
                    <td>
                      <span>{{row['updatedTime']}}</span>
                    </td>
                  </tr>
                </template>
              </datatable>
              <datatable-pager
                align="right"
                :style="navStaty"
                :per-page="per_page"
                type="short"
                v-model="page"
              ></datatable-pager>
            </div>
            <div class="col-sm-12" style="margin-top:-30px;">
              <div class="pull-right">
                <button class="btn btn-white" @click="gotoDetail">
                  {{$t("message.Add") }}
                </button>
                <button class="btn btn-white" @click="showWarning" v-if="$store.state.userInfo.systemUserRole.roleType==0">
                  {{$t("message.Delete") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import selectrow from "../components/common/selectRow";
import selectall from "../components/common/selectAll";
import eventBus from "../eventbus";
import config from "../config";

export default {
  name: "FloatingBanner",
  mixins: [config.globalMixin],
  data() {
    return {
      selectBanner: "",
      floatingBannerList: [],
      page: 1,
      per_page: 20,
      columns: [],
      trStyle: {
        cursor: "pointer"
      },
      navStaty: {
        "margin-top": "-30px",
        "margin-bottom": "15px",
        "margin-right": "30px"
      },
      selected_rows: [],
      searchName: "",
    };
  },
  created() {
    eventBus.$on(
      "selected",
      function(row) {
        if (this.selected_rows.indexOf(row) === -1) {
          this.selected_rows.push(row);
        }
      }.bind(this)
    );

    eventBus.$on(
      "deselected",
      function(row) {
        if (this.selected_rows.indexOf(row) !== -1) {
          let index = this.selected_rows.indexOf(row);
          this.selected_rows.splice(index, 1);
        }
      }.bind(this)
    );

    eventBus.$on(
      "select-all",
      function(selected) {
        Vue.set(this, "selected_rows", this.rows.slice(0));
      }.bind(this)
    );

    eventBus.$on(
      "deselect-all",
      function(selected) {
        Vue.set(this, "selected_rows", []);
      }.bind(this)
    );
  },
  mounted() {
    this.setColumns();
    this.getFloatingBannerList();
  },
  methods: {
    datataleCli: function(row){
      this.$router.push({
        path: "/main/floatingBannerDetail",
        query: { id: row.id }
      });
    },
    setColumns: function(){
      this.columns = [
        { label: "", align: "center", component: selectrow, headerComponent: selectall },
        // { label: this.$i18n.t("message.bannerImage"), field: "bannerImage" },
        { label: this.$i18n.t("message.bannerName"), field: "bannerName" },
        // { label: this.$i18n.t("message.bannerContent"), field: "content" },
        // { label: this.$i18n.t("message.buttonUrl"), field: "buttonUrl" },
        { label: this.$i18n.t("message.updatedTime"), field: "updatedTime"},
      ]
    },
    showWarning: function() {
      var that = this;
      if (this.selected_rows.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
            name:this.$i18n.t("message.Confirm"),
            callBack:function(){
              that.deleteList();
            }
          }, {
            name:this.$i18n.t("message.Cancel"),
            callBack:function(){
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            }
          }]
        });
      }
    },
    gotoDetail: function() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/floatingBannerDetail" });
    },
    async getFloatingBannerList() {
      let obj = this.getAuthObj;
      obj.startRow = 0;
      obj.maxRows = 10000;
      obj.bannerName = this.searchName;
      let data = await this.$store.dispatch("getFloatingBannerList", this.setFormData(obj));

      for(var i=0; i<data.data.resultList.length; i++) {
        for(var j=0; j<data.data.resultList[i].langMap.length; j++) {
          data.data.resultList[i]['bannerImage'] = data.data.resultList[i].langMap[j].bannerImage;

          if( data.data.resultList[i].langMap[j].langCode=="en_US" ){
            data.data.resultList[i]['bannerName'+'en_US'] = data.data.resultList[i].langMap[j].bannerName;
            data.data.resultList[i]['content'+'en_US'] = data.data.resultList[i].langMap[j].content;
            data.data.resultList[i]['buttonUrl'+'en_US'] = data.data.resultList[i].langMap[j].buttonUrl;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['bannerName'+'zh_HK'] = data.data.resultList[i].langMap[j].bannerName;
            data.data.resultList[i]['content'+'zh_HK'] = data.data.resultList[i].langMap[j].content;
            data.data.resultList[i]['buttonUrl'+'zh_HK'] = data.data.resultList[i].langMap[j].buttonUrl;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['bannerName'+'zh_CN'] = data.data.resultList[i].langMap[j].bannerName;
            data.data.resultList[i]['content'+'zh_CN'] = data.data.resultList[i].langMap[j].content;
            data.data.resultList[i]['buttonUrl'+'zh_CN'] = data.data.resultList[i].langMap[j].buttonUrl;
          }
        }
      }
      this.floatingBannerList = data.data.resultList;
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj;
      if (this.selected_rows.length != 0) {
        for (let i = 0; i < this.selected_rows.length; i++) {
          ids.push(this.selected_rows[i].id);
        }
      }
      objdata.ids = ids;

      let data = await this.$store.dispatch("deleteFloatingBanner", this.setFormData(objdata));
      if (data.data.errorCode === 0) {
        this.selected_rows=[]
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.getFloatingBannerList();
      }
    },
    async search() {
      this.getFloatingBannerList();
    },
  },
  components: {
    "select-row": selectrow,
    "select-all": selectall,
  },
  computed: {
    _language(){
      return this.$store.state.userInfo.langCode
    }
  },
  watch: {
    selected_rows: function() {
      for (var row of this.floatingBannerList) {
        if (this.selected_rows.indexOf(row) === -1) {
          return;
        }
      }
      eventBus.$emit("all-selected");
    },
    _language:function(){
      this.setColumns();
    }
  }
};
</script>

<style scoped>
.banner-select {
  display: flex;
  align-items: center;
}
.banner-content {
  margin-top: 30px;
}
.banner-list {
  margin-top: 15px;
}
</style>